import React, { useState } from "react";
import Images from "../../Component/Simage";
import { useEffect } from "react";
import { GetAllCmsData } from "../../Hooks/UseBackend";
function Banner() {
  const [CmsData, setCmsData] = useState([]);
  const [section1, setsection1] = useState();

  useEffect(() => {
    getCmsData();
  }, []);

  const getCmsData = async () => {
    console.log("enterthis");
    let res = await GetAllCmsData();

    if (res.data) {
      setsection1(res.data.find((value) => (value.identifier == 'DePIN')))
    }


    setCmsData(res.data);
  };
  return (
    <div className="depin_banner">
      <div className="heading_sec">
        <h1 className="title-txt text-center">
          {section1 && section1?.Title}        </h1>
        <h6 className="section-videoBanner__content-desc">
          {section1 && section1?.Content}
        </h6>
      </div>
      <div className="bnr_sec">
        <div className="position-relative">
          <img src={Images.depinBannerBg} className="bg_src img-fluid" />
          {/* <img src={Images.depinBannerGif} className="gif_src img-fluid" /> */}
          <video autoPlay muted loop className="gif_src img_src">
            <source src={Images.depinBannerGif} type="video/mp4" />
          </video>
        </div>
        <div className="tdl_cnt">
          <div className="count_sec">
            <div className="items">
              <div>
                <p className="title-txt fw-500">Total Depin</p>
                <h4 className="value-txt fw-700">261,207</h4>
              </div>
            </div>
            <div className="items">
              <div>
                <p className="title-txt fw-500">Data File Batches</p>
                <h4 className="value-txt fw-700">21,514,559</h4>
              </div>
            </div>
            <div className="items">
              <div>
                <p className="title-txt fw-500">Data Delivery</p>
                <h4 className="value-txt fw-700">13,208.904 TB</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
